import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bi_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("bi_token");
      localStorage.removeItem("bi_user");
      if (window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  },
);

export const setAuth = (token, user) => {
  localStorage.setItem("bi_token", token);
  localStorage.setItem("bi_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("bi_token");
  localStorage.removeItem("bi_user");
};
export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("bi_user") || "null");
  } catch {
    return null;
  }
};
export const isAuthed = () => !!localStorage.getItem("bi_token");

export const STATUS_META = {
  verified: { label: "Terverifikasi", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  pending: { label: "Menunggu Verifikasi", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  needs_fix: { label: "Minta Perbaikan", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
  draft: { label: "Belum Lengkap", cls: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
};

export const DOC_META = {
  kartu_keluarga: { label: "Kartu Keluarga (KK)" },
  akta_kelahiran: { label: "Akta Kelahiran" },
  ijazah_sd: { label: "Ijazah SD/MI" },
  pas_foto: { label: "Pas Foto 3x4" },
};

// SMPN 1 Penengahan: 27 rombel — 7A..7I, 8A..8I, 9A..9I
export const KELAS_LIST = ["A", "B", "C", "D", "E", "F", "G", "H", "I"].flatMap((h) =>
  [7, 8, 9].map((t) => `${t}${h}`)
).sort();

export const fileUrl = (path) => `${API}/files/${path}`;
